import {DirectusProvider} from "./app/DirectusProvider";
import AppRouter from "./app/AppRouter";
import MainMenu from "./components/MainMenu";
import {ToastContainer} from "react-toastify";

import React from "react";

function App() {
    return (
        <>
            <DirectusProvider>
                <AppRouter>
                    <MainMenu/>
                </AppRouter>
            </DirectusProvider>
            <ToastContainer position="bottom-right"/>
        </>
    );
}

export default App;
